import React from "react";
import { thaiStudentPic } from "../../assets/images";
import ButtonPrimary from "../../components/ButtonPrimary";
import { FiEdit } from "react-icons/fi";
import SelectedField from "../../components/SelectedField";
import {
  barGraphIcon,
  feverIcon,
  growthChartIcon,
  immigrationIcon,
  temperatureIcon,
} from "../../assets/icons/index";
import TableTempurture from "./tables/TableTempurture";
import TableGrowth from "./tables/TableGrowth";
import TableHistoryillness from "./tables/TableHistoryillness";
import TableAttendance from "./tables/TableAttendance";
import TableDashboard from "./tables/TableDashboard";
export default function PersonalStudentPage() {
  return (
    <div>
      <div className="box-profile-student">
        <div className="row-jcct-py1-5">
          <p className="txt-main-content1">Profile</p>
        </div>
        <div className="box-inside-profile-student">
          <div className="row-jcsb-atct">
            <div className="row-gab1">
              <div className="col-gab1">
                <p className="txt-sub-explanation1">First Name</p>
                <p className="txt-sub-explanation1">Last Name</p>
                <p className="txt-sub-explanation1">Student ID</p>
                <p className="txt-sub-explanation1">Adviser Name</p>
                <p className="txt-sub-explanation1">Remark </p>
              </div>
              <div className="col-gab1">
                <p className="txt-sub-explanation1">Pataraphon</p>
                <p className="txt-sub-explanation1">Threekan</p>
                <p className="txt-sub-explanation1">533442</p>
                <p className="txt-sub-explanation1">T.Panudet</p>
                <p className="txt-sub-explanation1">- </p>
              </div>
            </div>
            <div className="row-gab1">
              <div className="col-gab1">
                <p className="txt-sub-explanation1">Class</p>
                <p className="txt-sub-explanation1">Room</p>
                <p className="txt-sub-explanation1">Club</p>
                <p className="txt-sub-explanation1">Parent Name</p>
              </div>
              <div className="col-gab1">
                <p className="txt-sub-explanation1">3</p>
                <p className="txt-sub-explanation1">14</p>
                <p className="txt-sub-explanation1">-</p>
                <p className="txt-sub-explanation1">T.Panudet</p>
              </div>
            </div>
            <img className="box-image-profile" src={thaiStudentPic}></img>
          </div>
          <div className="box-top-left-button">
            <ButtonPrimary
              style={{ padding: "0.5rem" }}
              text={<FiEdit />}
              className={"text-button"}
            />
          </div>
        </div>
      </div>
      <div className="row-jcct-pt2-2">
        <SelectedField
          listImage={[
            {
              title: "Dashboard",
              image: barGraphIcon,
              page: <TableDashboard />,
            },
            {
              title: "Tempature",
              image: temperatureIcon,
              page: <TableTempurture />,
            },
            {
              title: "Attendance",
              image: immigrationIcon,
              page: <TableAttendance />,
            },
            {
              title: "History illness",
              image: feverIcon,
              page: <TableHistoryillness />,
            },
            {
              title: "Growth",
              image: growthChartIcon,
              page: <TableGrowth />,
            },
          ]}
        />
      </div>
    </div>
  );
}
